// src/components/KanbanColumn.js
import React from 'react';
import KanbanCard from './KanbanCard';

function KanbanColumn({ coluna, oportunidades, onDragStart, onDragOver, onDrop, onRecarregar, onDeletar }) {
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('drag-over');
  };

  const handleDragLeave = (e) => {
    e.currentTarget.classList.remove('drag-over');
  };

  const handleDrop = (e) => {
    e.currentTarget.classList.remove('drag-over');
    onDrop(e, coluna.id);
  };

  return (
    <div 
      className="kanban-column"
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className="kanban-column-header">
        <h3 className="kanban-column-title">
          <span className={`status-dot status-${coluna.cor}`}></span>
          {coluna.titulo}
          <span className="kanban-column-count">{oportunidades.length}</span>
        </h3>
        <button className="kanban-column-menu">⋮</button>
      </div>

      <div className="kanban-column-content">
        {oportunidades.map(opp => (
          <KanbanCard
            key={opp.id}
            oportunidade={opp}
            onDragStart={onDragStart}
            onRecarregar={onRecarregar}
            onDeletar={onDeletar}
          />
        ))}
        
        {oportunidades.length === 0 && (
          <div className="kanban-empty">
            Nenhuma oportunidade
          </div>
        )}
      </div>
    </div>
  );
}

export default KanbanColumn;
